export enum RouteActions {
  Reschedule = 'Reschedule',
  Rebook = 'Rebook',
}
